"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SankeySettingsEditionTags = exports.SankeySettingsEdition = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SankeyLayout = require("./SankeyLayout");

var _types = require("./types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SankeySettingsEditionPropTypes = {
  data: _propTypes.default.shape(_types.SankeyDataPropTypes).isRequired,
  set_data: _propTypes.default.func.isRequired,
  set_current_filter: _propTypes.default.func.isRequired,
  getValueIndex: _propTypes.default.func.isRequired
};

var SankeySettingsEdition = function SankeySettingsEdition(_ref) {
  var data = _ref.data,
      set_data = _ref.set_data,
      set_current_filter = _ref.set_current_filter,
      getValueIndex = _ref.getValueIndex,
      children = _ref.children;
  var file_layout;

  var _useState = (0, _react.useState)(100),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      shift_left = _useState2[0],
      set_shift_left = _useState2[1];

  var _useState3 = (0, _react.useState)(100),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      shift_top = _useState4[0],
      set_shift_top = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      shift_visible = _useState6[0],
      set_shift_visible = _useState6[1];

  var _useState7 = (0, _react.useState)(data.user_scale),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      user_scale = _useState8[0],
      set_user_scale = _useState8[1];

  var _useState9 = (0, _react.useState)(data.legend_position),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      legend_position = _useState10[0],
      set_legend_position = _useState10[1];

  var _useState11 = (0, _react.useState)(data.width),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      width = _useState12[0],
      set_width = _useState12[1];

  var _useState13 = (0, _react.useState)(data.h_space),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      node_hspace = _useState14[0],
      set_node_hspace = _useState14[1];

  var _useState15 = (0, _react.useState)(data.v_space),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      node_vspace = _useState16[0],
      set_node_vspace = _useState16[1];

  var display_style = data.display_style,
      links = data.links,
      nodes = data.nodes,
      node_width = data.node_width;
  var filter = display_style.filter;
  var value_index = getValueIndex(data);
  var max_link_value = 0;
  Object.values(links).forEach(function (link) {
    if (link.value[value_index] > max_link_value) {
      max_link_value = link.value[value_index];
    }
  });
  max_link_value += 1;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tabs, {
    defaultActiveKey: "geometry",
    id: "settings-layout"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "geometry",
    title: "G\xE9ometrie"
  }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Echelle")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
    type: "text",
    value: user_scale,
    onChange: function onChange(evt) {
      return set_user_scale(+evt.target.value);
    },
    onBlur: function onBlur() {
      data.user_scale = user_scale;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Text, null, "    (valeur pour 100px)"))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Largeur")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
    type: "text",
    value: width,
    onChange: function onChange(evt) {
      return set_width(+evt.target.value);
    },
    onBlur: function onBlur() {
      data.width = width;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "D\xE9placer visible seulement",
    checked: shift_visible,
    onChange: function onChange(evt) {
      set_shift_visible(evt.target.checked);
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Shift horizontal")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
    type: "text",
    value: shift_left,
    onChange: function onChange(evt) {
      return set_shift_left(+evt.target.value);
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    onClick: function onClick() {
      if (shift_visible) {
        Object.values(nodes).filter(function (n) {
          return n.node_visible;
        }).forEach(function (n) {
          return n.x += shift_left;
        });
        Object.values(links).filter(function (l) {
          return nodes[l.idSource].node_visible && nodes[l.idTarget].node_visible && l.x_label;
        }).forEach(function (l) {
          return l.x_label += shift_left;
        });
      } else {
        Object.values(nodes).forEach(function (n) {
          return n.x += shift_left;
        });
        Object.values(links).filter(function (l) {
          return l.x_label;
        }).forEach(function (l) {
          return l.x_label += shift_left;
        });
      }

      set_data((0, _objectSpread2.default)({}, data));
    }
  }, "D\xE9placer"))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Shift vertical")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
    type: "text",
    value: shift_top,
    onChange: function onChange(evt) {
      return set_shift_top(+evt.target.value);
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    onClick: function onClick() {
      if (shift_visible) {
        Object.values(nodes).filter(function (n) {
          return n.node_visible;
        }).forEach(function (n) {
          return n.y += shift_top;
        });
        Object.values(links).filter(function (l) {
          return nodes[l.idSource].node_visible && nodes[l.idTarget].node_visible && l.y_label;
        }).forEach(function (l) {
          return l.y_label += shift_top;
        });
      } else {
        Object.values(nodes).forEach(function (n) {
          return n.y += shift_top;
        });
        Object.values(links).filter(function (l) {
          return l.y_label;
        }).forEach(function (l) {
          return l.y_label += shift_top;
        });
      }

      set_data((0, _objectSpread2.default)({}, data));
    }
  }, "D\xE9placer"))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "L\xE9gende X")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
    type: "text",
    value: legend_position[0],
    onChange: function onChange(evt) {
      return set_legend_position([+evt.target.value, legend_position[1]]);
    },
    onBlur: function onBlur() {
      data.legend_position = legend_position;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "L\xE9gende Y")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
    type: "text",
    value: legend_position[1],
    onChange: function onChange(evt) {
      return set_legend_position([legend_position[0], +evt.target.value]);
    },
    onBlur: function onBlur() {
      data.legend_position = legend_position;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "layout",
    title: "Positionnement"
  }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Layout")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "file",
    onChange: function onChange(evt) {
      return file_layout = evt.target.files;
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    onClick: function onClick() {
      if (file_layout === undefined) {
        return;
      }

      var reader = new FileReader();

      reader.onload = function () {
        return function (e) {
          var result = e.target.result;

          if (result) {
            result = String(result).split('<br>').join('\\\\n');
            var new_layout = JSON.parse(result);
            (0, _SankeyLayout.updateLayout)(data, new_layout);
            set_data((0, _objectSpread2.default)({}, data));
          }
        };
      }();

      reader.readAsText(file_layout[0]);
    }
  }, "Appliquer Layout"))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "D\xE9finition de la Grille")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Horizontal")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
    type: "text",
    value: node_hspace,
    onChange: function onChange(evt) {
      set_node_hspace(+evt.target.value);
      data.h_space = +evt.target.value;
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Vertical")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
    type: "text",
    value: node_vspace,
    onChange: function onChange(evt) {
      set_node_vspace(+evt.target.value);
      data.v_space = +evt.target.value;
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    onClick: function onClick() {
      (0, _SankeyLayout.arrangeNodes)(data, node_hspace, node_vspace);
      set_data((0, _objectSpread2.default)({}, data));
    }
  }, "Arranger noeuds")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    onClick: function onClick() {
      (0, _SankeyLayout.compute_auto_sankey)(data, node_hspace);
      set_data((0, _objectSpread2.default)({}, data));
    }
  }, " Positionnement automatique"))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    onClick: function onClick() {
      Object.values(data.nodes).forEach(function (n) {
        (0, _SankeyLayout.reorganize_node_inputLinksId)(n, data.nodes, data.links);
        (0, _SankeyLayout.reorganize_node_outputLinksId)(n, data.nodes, data.links);
      });
      set_data((0, _objectSpread2.default)({}, data));
    }
  }, "Reorganiser liens entrants et sortant"))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "nodes",
    title: "Noeuds"
  }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Taille minimum")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Range, {
    min: "0",
    max: "100",
    value: node_width,
    onChange: function onChange(evt) {
      data.node_width = +evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, node_width)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Taille police")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Range, {
    min: "11",
    max: "20",
    value: display_style.font_size,
    onChange: function onChange(evt) {
      display_style.font_size = +evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, display_style.font_size)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Secteurs")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Bold",
    checked: display_style.sector_bold,
    onChange: function onChange(evt) {
      display_style.sector_bold = evt.target.checked;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Upper",
    checked: display_style.sector_uppercase,
    onChange: function onChange(evt) {
      display_style.sector_uppercase = evt.target.checked;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Italic",
    checked: display_style.sector_italic,
    onChange: function onChange(evt) {
      display_style.sector_italic = evt.target.checked;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Produits")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Bold",
    checked: display_style.product_bold,
    onChange: function onChange(evt) {
      display_style.product_bold = evt.target.checked;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Upper",
    checked: display_style.product_uppercase,
    onChange: function onChange(evt) {
      display_style.product_uppercase = evt.target.checked;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Italic",
    checked: display_style.product_italic,
    onChange: function onChange(evt) {
      display_style.product_italic = evt.target.checked;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    style: {
      'marginBottom': '3px'
    },
    onClick: function onClick() {
      Object.values(data.nodes).filter(function (n) {
        return n.node_visible;
      }).forEach(function (n) {
        delete n.x_label;
        delete n.y_label;
      });
    }
  }, "Reset label position"))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "flux",
    title: "Flux"
  }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Filtre")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Range, {
    min: "0",
    max: max_link_value,
    value: filter,
    onChange: function onChange(evt) {
      return set_current_filter(Number(evt.target.value));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, filter)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Filtre label")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Range, {
    min: "0",
    max: max_link_value,
    value: display_style.filter_label,
    onChange: function onChange(evt) {
      display_style.filter_label = +evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, display_style.filter_label)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Type :")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Courbe",
    onChange: function onChange(evt) {
      Object.values(data.links).filter(function (l) {
        return data.nodes[l.idSource].node_visible && data.nodes[l.idTarget].node_visible;
      }).forEach(function (l) {
        return l.curved = evt.target.checked;
      });
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Fl\xEAche",
    onChange: function onChange(evt) {
      Object.values(data.links).filter(function (l) {
        return data.nodes[l.idSource].node_visible && data.nodes[l.idTarget].node_visible;
      }).forEach(function (l) {
        return l.arrow = evt.target.checked;
      });
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Courbure")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Range, {
    min: "0",
    max: "1",
    step: "0.1",
    value: display_style.global_curvature,
    onChange: function onChange(evt) {
      display_style.global_curvature = +evt.target.value;
      Object.values(data.links).filter(function (l) {
        return data.nodes[l.idSource].node_visible && data.nodes[l.idTarget].node_visible;
      }).forEach(function (l) {
        return l.curvature = +evt.target.value;
      });
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, display_style.global_curvature)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Label:")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    name: "label",
    label: "D\xE9but",
    value: "beginning",
    type: "radio",
    onChange: function onChange(evt) {
      Object.values(data.links).filter(function (l) {
        return data.nodes[l.idSource].node_visible && data.nodes[l.idTarget].node_visible;
      }).forEach(function (l) {
        return l.label_position = evt.target.value;
      });
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    name: "label",
    label: "Milieu",
    value: "middle",
    type: "radio",
    onChange: function onChange(evt) {
      Object.values(data.links).filter(function (l) {
        return data.nodes[l.idSource].node_visible && data.nodes[l.idTarget].node_visible;
      }).forEach(function (l) {
        return l.label_position = evt.target.value;
      });
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    name: "label",
    label: "Fin",
    value: "end",
    type: "radio",
    onChange: function onChange(evt) {
      Object.values(data.links).filter(function (l) {
        return data.nodes[l.idSource].node_visible && data.nodes[l.idTarget].node_visible;
      }).forEach(function (l) {
        return l.label_position = evt.target.value;
      });
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Attach\xE9 au flux",
    onChange: function onChange(evt) {
      Object.values(data.links).filter(function (l) {
        return data.nodes[l.idSource].node_visible && data.nodes[l.idTarget].node_visible;
      }).forEach(function (l) {
        return l.label_on_path = evt.target.checked;
      });
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    name: "color",
    value: "black",
    type: "radio",
    label: "Label en noir",
    onChange: function onChange() {
      Object.values(data.links).filter(function (l) {
        return data.nodes[l.idSource].node_visible && data.nodes[l.idTarget].node_visible;
      }).forEach(function (l) {
        return l.text_color = 'black';
      });
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    name: "color",
    value: "white",
    type: "radio",
    label: "Label blanc",
    onChange: function onChange() {
      Object.values(data.links).filter(function (l) {
        return data.nodes[l.idSource].node_visible && data.nodes[l.idTarget].node_visible;
      }).forEach(function (l) {
        return l.text_color = 'white';
      });
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    name: "color",
    value: "same_color",
    type: "radio",
    label: "Label en couleur",
    onChange: function onChange() {
      Object.values(data.links).filter(function (l) {
        return data.nodes[l.idSource].node_visible && data.nodes[l.idTarget].node_visible;
      }).forEach(function (l) {
        return l.text_color = l.color;
      });
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Label visible",
    onChange: function onChange(evt) {
      Object.values(data.links).filter(function (l) {
        return data.nodes[l.idSource].node_visible && data.nodes[l.idTarget].node_visible;
      }).forEach(function (l) {
        return l.label_visible = evt.target.checked;
      });
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Taille police")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Range, {
    min: "11",
    max: "20",
    value: display_style.font_size,
    onChange: function onChange(evt) {
      display_style.font_size = +evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, display_style.font_size)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Flux Nuls:")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Visible",
    onChange: function onChange(evt) {
      data.display_style.null_flux = evt.target.checked;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))))), children);
};

exports.SankeySettingsEdition = SankeySettingsEdition;
var SankeySettingsEditionTagsPropTypes = {
  data: _propTypes.default.shape(_types.SankeyDataPropTypes).isRequired,
  set_data: _propTypes.default.func.isRequired,
  getValueIndex: _propTypes.default.func.isRequired
};

var SankeySettingsEditionTags = function SankeySettingsEditionTags(_ref2) {
  var data = _ref2.data,
      set_data = _ref2.set_data,
      getValueIndex = _ref2.getValueIndex;

  var _useState17 = (0, _react.useState)(Object.keys(data.tags_catalog).length > 0 ? Object.keys(data.tags_catalog)[0] : ''),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      tags_group_key = _useState18[0],
      set_tags_group_key = _useState18[1]; //const [tag_key, set_tag_key] = useState('')


  var links = data.links,
      tags_catalog = data.tags_catalog;
  var value_index = getValueIndex(data);
  var max_link_value = 0;
  Object.values(links).forEach(function (link) {
    if (link.value[value_index] > max_link_value) {
      max_link_value = link.value[value_index];
    }
  });
  max_link_value += 1;
  /*   const handleBanner = (i: number, evt: React.ChangeEvent<HTMLSelectElement>) => {
      tags_catalog[i].banner = evt.target.value
      set_data({ ...data })
    } */

  var handleBanner = function handleBanner(tags_group_key, evt) {
    tags_catalog[tags_group_key].banner = evt.target.value;
    set_data((0, _objectSpread2.default)({}, data));
  }; // --------------------------------------------


  var handleAddTagButton = function handleAddTagButton() {
    var tags_catalog = data.tags_catalog;
    tags_catalog[tags_group_key].tags['element' + data.tag_idx] = {
      name: 'tag' + data.tag_idx,
      color: '#000000',
      selected: true
    };
    data.tag_idx += 1;
    set_data((0, _objectSpread2.default)({}, data));
  };

  var handleAddTagGrpButton = function handleAddTagGrpButton() {
    var tags_catalog = data.tags_catalog; //const tab_key = Object.keys(tags_catalog)
    // let tmp_key = key_group_tag
    // if (tab_key.length > 0) {
    //   tmp_key = parseInt(tab_key[tab_key.length - 1].slice(10)) + 1
    // }

    data.tags_group_idx += 1;
    tags_catalog['tag_group_' + data.tags_group_idx] = {
      group_name: 'Tag Group ' + data.tags_group_idx,
      show_legend: false,
      tags: {},
      banner: 'none'
    }; //set_key_group_tag(tmp_key + 1)
    // if (Object.keys(tags_catalog).length == 1) {
    //   set_tags_group_key(tmp_key)
    // }

    set_tags_group_key('tag_group_' + data.tags_group_idx);
    set_data((0, _objectSpread2.default)({}, data));
  };

  var handleDelTag = function handleDelTag(n) {
    var tags_catalog = data.tags_catalog;
    delete tags_catalog[tags_group_key].tags[n];
    set_data((0, _objectSpread2.default)({}, data));
  };

  var handleDelGroupTag = function handleDelGroupTag(i) {
    var tags_catalog = data.tags_catalog;
    console.log(i);
    delete tags_catalog[i];

    if (Object.keys(tags_catalog).length > 0) {
      var lastElmt = Object.keys(tags_catalog)[Object.keys(tags_catalog).length - 1];
      set_tags_group_key(lastElmt);
    }

    set_data((0, _objectSpread2.default)({}, data));
  }; // const handleBanner = (i: string, evt: React.ChangeEvent<HTMLSelectElement>) => {
  //   const { tags_catalog } = data
  //   tags_catalog[i].banner = evt.target.value
  //   set_data({ ...data })
  // }
  // const optionTag = () => {
  //   if (Object.keys(tags_catalog).length == 0) {
  //     return <option></option>
  //   } else {
  //     return Object.entries(tags_catalog[tags_group_key].tags).map(
  //       (tag, i) =>
  //         <option
  //           key={i}
  //           value={tag[0]}
  //           selected={tags_catalog[tags_group_key].tags[tag[0]] == tags_catalog[tags_group_key].tags[tag[0]]} >
  //           {tag[1].name}
  //         </option>)
  //   }
  // }


  var tagSetting = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Tag Groupe:")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
    onChange: function onChange(evt) {
      set_tags_group_key(evt.target.value);
      set_data((0, _objectSpread2.default)({}, data));
    }
  }, Object.keys(tags_catalog).map(function (key, i) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: i,
      value: key,
      selected: tags_group_key === key
    }, tags_catalog[key].group_name);
  })))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Table, {
    striped: true,
    bordered: true,
    hover: true,
    responsive: "sm",
    size: "sm"
  }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", null, "Nom"), /*#__PURE__*/_react.default.createElement("th", null, "Visible"), /*#__PURE__*/_react.default.createElement("th", null, "Couleur"), /*#__PURE__*/_react.default.createElement("th", null, "Shape"))), /*#__PURE__*/_react.default.createElement("tbody", null, Object.keys(tags_catalog).length > 0 && tags_group_key !== '' ? Object.keys(tags_catalog[tags_group_key].tags).map(function (tag_key, i) {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: i.toString()
    }, /*#__PURE__*/_react.default.createElement("td", {
      style: {
        'width': '10%'
      }
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
      variant: "danger",
      value: "-",
      onClick: function onClick() {
        handleDelTag(tag_key);
      }
    }, "-")), /*#__PURE__*/_react.default.createElement("td", {
      style: {
        'width': '33%'
      }
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
      size: "sm",
      id: i.toString(),
      type: "text",
      value: tags_catalog[tags_group_key].tags[tag_key].name,
      onChange: function onChange(evt) {
        var tags_catalog = data.tags_catalog;
        var new_nb_element = evt.target;
        var name = new_nb_element.value;
        tags_catalog[tags_group_key].tags[tag_key].name = name;
        set_data((0, _objectSpread2.default)({}, data));
      }
    })), /*#__PURE__*/_react.default.createElement("td", {
      style: {
        'width': '10%'
      }
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
      inline: true,
      name: 'element_visible' + tag_key,
      checked: tags_catalog[tags_group_key].tags[tag_key].selected,
      id: tag_key,
      type: "switch",
      onChange: function onChange(evt) {
        var new_nb_element = evt.target;
        var tag_key = new_nb_element.id;
        var visible = new_nb_element.checked;
        tags_catalog[tags_group_key].tags[tag_key].selected = visible;
        set_data((0, _objectSpread2.default)({}, data));
      }
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
      type: "color",
      value: tags_catalog[tags_group_key].tags[tag_key].color,
      onChange: function onChange(evt) {
        tags_catalog[tags_group_key].tags[tag_key].color = evt.target.value;
        set_data((0, _objectSpread2.default)({}, data));
      }
    })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
      onChange: function onChange(evt) {
        tags_catalog[tags_group_key].tags[tag_key].shape = evt.target.value;
        set_data((0, _objectSpread2.default)({}, data));
      }
    }, /*#__PURE__*/_react.default.createElement("option", {
      key: 'rect' + i,
      id: "rect",
      selected: tags_catalog[tags_group_key].banner === 'one',
      value: "rect"
    }, "Rectangle"), /*#__PURE__*/_react.default.createElement("option", {
      key: 'circle' + i,
      id: "circle",
      selected: tags_catalog[tags_group_key].banner === 'multi',
      value: "circle"
    }, "Circle")));
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "success",
    value: "+",
    onClick: handleAddTagButton
  }, "+"), " ");

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Table, {
    striped: true,
    bordered: true,
    hover: true
  }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", null, "Nom"), /*#__PURE__*/_react.default.createElement("th", null, "Legend"), /*#__PURE__*/_react.default.createElement("th", null, "Nb tag"), /*#__PURE__*/_react.default.createElement("th", null, "Banni\xE8re"))), /*#__PURE__*/_react.default.createElement("tbody", null, Object.keys(tags_catalog).map(function (tags_group_key, i) {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: i.toString()
    }, /*#__PURE__*/_react.default.createElement("td", {
      style: {
        'width': '10%'
      }
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
      variant: "danger",
      onClick: function onClick() {
        return handleDelGroupTag(tags_group_key);
      }
    }, "-")), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
      id: i.toString(),
      type: "text",
      value: tags_catalog[tags_group_key].group_name,
      onChange: function onChange(evt) {
        var tags_catalog = data.tags_catalog;
        var new_name = evt.target.value;
        tags_catalog[tags_group_key].group_name = new_name;
        set_data((0, _objectSpread2.default)({}, data));
      }
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
      inline: true // Permet de selection le tag pour l'affichage dans la légende
      ,
      name: 'element_legend_' + tags_group_key,
      checked: tags_catalog[tags_group_key].show_legend,
      id: tags_group_key,
      type: "switch",
      onChange: function onChange(evt) {
        var new_nb_element = evt.target;
        var tags_group_key = new_nb_element.id;
        var visible = new_nb_element.checked;
        tags_catalog[tags_group_key].show_legend = visible;
        set_data((0, _objectSpread2.default)({}, data));
      }
    })), /*#__PURE__*/_react.default.createElement("td", null, Object.keys(tags_catalog[tags_group_key].tags).length), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
      onChange: function onChange(evt) {
        return handleBanner(tags_group_key, evt);
      }
    }, /*#__PURE__*/_react.default.createElement("option", {
      key: 'none' + i,
      id: "NoneBaner",
      selected: tags_catalog[tags_group_key].banner === 'none' || !tags_catalog[tags_group_key].banner,
      value: "none"
    }, "None"), /*#__PURE__*/_react.default.createElement("option", {
      key: 'one' + i,
      id: "OneBaner",
      selected: tags_catalog[tags_group_key].banner === 'one',
      value: "one"
    }, "One"), /*#__PURE__*/_react.default.createElement("option", {
      key: 'multi' + i,
      id: "MultipleBaner",
      selected: tags_catalog[tags_group_key].banner === 'multi',
      value: "multi"
    }, "Multi")));
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "success",
    onClick: handleAddTagGrpButton
  }, "+"), /*#__PURE__*/_react.default.createElement("br", null), Object.keys(tags_catalog).length > 0 ? tagSetting : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
};

exports.SankeySettingsEditionTags = SankeySettingsEditionTags;
var _default = null;
exports.default = _default;